import React from 'react'
import { grey } from '@material-ui/core/colors'
import { CircularProgress, Grid, Icon, IconButton, LinearProgress, makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core'
import GenericStatus from '../../../../components_v1/Structure/DisplayData/GenericStatus'
import AvatarName from '../../../../components_v1/Structure/DisplayData/AvatarName'
import DisplayText from '../../../../components_v1/Texts/DisplayText'
import { catalogs } from '../../../../texts/esp/catalogs'
import empty from '../../../../assets/empty.png'
import FilterButton from './FilterButton'
import ActionBar from './ActionBar'
import SearchBar from '../../../../components_v1/Actions/SearchBar/SearchBar'
import { onGetYearCatalog } from '../../../../shared/utility'

const useStyles = makeStyles(theme => ({
    root: {},
    paper: {
        borderRadius: 8,
        boxShadow: '0 10px 24px 0 rgba(82, 91, 115, .12)',
    },
    cell: {
        borderColor: grey[200],
    },
    row: {
        '&:hover': {
            cursor: 'pointer',
            background: grey[100]
        }
    },
    cellHeader: {
        borderColor: grey[300],
        paddingTop: 16,
        paddingBottom: 16
    },
    button: {
        background: theme.palette.primary.main,
        padding: '6px 12px',
        borderRadius: 32,
        color: 'white',
        '&:hover': {
            background: theme.palette.primary.dark,
        }
    },
    toolbar: {
        marginBottom: 16
    },
    actions: {
        marginTop: 16
    },
    table: {
        minWidth: 1100
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    nodata: {
        marginTop: 40
    }
}))

const SimpleTable = props => {

    const classes = useStyles()
    const { origin_data, data, header, onChangeFilter, total, tableFilter, onUpdateTableFilter,
        onSelectedItem, loading, year, month, monthCatalog, generatePDF, onChangeSearch, search, periodCatalog, period } = props

    const noContent = (
        <div className={classes.nodata}>
            <Grid container justify='center' alignItems='center' direction='column'>
                <Grid item>
                    <img src={empty} alt='' width={180} />
                </Grid>
                <Grid item>
                    <DisplayText>No se encontraron registros</DisplayText>
                </Grid>
            </Grid>
        </div>
    )

    return (
        <div>
            <div className={classes.toolbar}>
                
                <Grid container wrap='nowrap' spacing={2} alignItems='flex-end'>
                    <Grid item>
                        <FilterButton label='Periodo' options={periodCatalog} selected={period} onChange={(val) => onChangeFilter(val, 'period')} />
                    </Grid>
                    <Grid item>
                        <FilterButton label='Año' options={onGetYearCatalog()} selected={year} onChange={(val) => onChangeFilter(val, 'year')} />
                    </Grid>
                    <Grid item xs></Grid>
                    <Grid item><SearchBar onUpdateTableFilter={onUpdateTableFilter} tableFilter={tableFilter} value={search} onChange={onChangeSearch}/></Grid>
                </Grid>
                   
            </div>
            {loading ? (
                <Grid container justify='center'>
                    <Grid item xs={12}><LinearProgress /></Grid>
                </Grid>
            ) : null}
            <Paper className={classes.paper}>
                {data && data.length ? (
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table}>
                            {header ? (
                                <TableHead>
                                    <TableRow>
                                        {header.map(item => {
                                            return (
                                                <TableCell padding={item.id === 1 ? 'default' : 'default'} className={classes.cellHeader} key={item.id.toString()}>
                                                    <DisplayText variant='subtitle2' >{item.label}</DisplayText>
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                </TableHead>
                            ) : null}
                            <TableBody>
                                {data.map((item, key) => {
                                    const { id_employee_evaluation, evaluated, total, evaluation_date, evaluation_step_id, image, date } = item

                                    return (
                                        <TableRow key={key.toString()} className={classes.row} >
                                            <TableCell className={classes.cell} onClick={() => onSelectedItem(item)}><DisplayText variant='body2'>{id_employee_evaluation}</DisplayText></TableCell>
                                            <TableCell className={classes.cell} onClick={() => onSelectedItem(item)}><DisplayText variant='body2'>{date}</DisplayText></TableCell>
                                            <TableCell className={classes.cell} onClick={() => onSelectedItem(item)}><AvatarName name={evaluated} imgSrc={image} /></TableCell>
                                            <TableCell className={classes.cell} onClick={() => onSelectedItem(item)}><GenericStatus id={evaluation_step_id} variant='body2' options={catalogs.steps} /></TableCell>
                                            <TableCell className={classes.cell} onClick={() => onSelectedItem(item)}><DisplayText variant='body2'>{total}</DisplayText></TableCell>
                                            
                                            <TableCell className={classes.cell} onClick={() => onSelectedItem(item)}><DisplayText variant='body2'>{evaluation_date}</DisplayText></TableCell>
                                            <TableCell className={classes.cell}>
                                                <IconButton styles={{ padding: 8 }} color='primary' disabled={evaluation_step_id !== 6} onClick={() => generatePDF(origin_data[key])}>
                                                    <Icon fontSize='small'>cloud_download</Icon>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}

                            </TableBody>
                        </Table>
                    </div>

                ) : null}
            </Paper>
            {data && data.length ? <div className={classes.actions}>
                <ActionBar total={total} tableFilter={tableFilter} onUpdateTableFilter={onUpdateTableFilter} />
            </div> : null}
            {data.length === 0 && !loading ? noContent : null}
        </div>
    )
}

export default SimpleTable